/** Bill payment statuses */
export enum BillPaymentStatusEnum {
  /** Bill not paid (default value) */
  NOT_PAID = 'NOT_PAID',
  /** Bill paid in full */
  PAID = 'PAID',
  /** Bill partially paid */
  PARTIALLY_PAID = 'PARTIALLY_PAID',
}
